import { ForwardedRef, forwardRef, useContext } from 'react'
import { Position } from 'types'
import { Renderable } from '../classes/renderer'
import Shader from '../classes/shader'
import { ArtboardContext } from '../context'
import { useTexture } from '../hooks/use-texture'
import { ArtboardTextureLayerProps } from '../types'
import ArtboardLayer from './base'

const ArtboardTexture = (
    { mirrored = false, source, ...rest }: ArtboardTextureLayerProps,
    ref: ForwardedRef<Renderable>
) => {
    const { renderer } = useContext(ArtboardContext)
    const texture = useTexture(renderer, source)

    function onDraw(position: Position, shader: Shader) {
        if (!texture) return

        shader.drawImage({ ...position, mirrored, texture })
    }

    return <ArtboardLayer {...rest} ref={ref} onDraw={onDraw} />
}

export default forwardRef(ArtboardTexture)
